document.addEventListener('DOMContentLoaded', function() {
    var projects = document.getElementsByClassName('js_project');

    for (var i = 0; i < projects.length; i++) {
        var project = projects[i];
        var content = project.querySelector('.js_limited-content');
        var btn = project.querySelector('.js_expand-btn');

        if (content.offsetHeight > 196) {
            btn.classList.add('visible');
            content.classList.add('limited');
        }

        btn.addEventListener('click', function(e) {
            e.preventDefault();
            e.target.closest('.js_project').querySelector('.js_limited-content').classList.toggle('open');
            e.currentTarget.classList.toggle('open');
        });
    }
});
